import i18n from './i18next';

export default {
    // host: `http://react.rizanova.loc/api`,
    // api: `http://react.rizanova.loc/api`,
    // site: "http://react.rizanova.loc",
    // host: `http://react.rizanova.site/api`,
    // api: `http://react.rizanova.site/api`,
    // site: "http://react.rizanova.site",
    host: `https://rizanova.site/api`,
    api: `https://rizanova.site/api`,
    site: "https://rizanova.site",
}